import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import {
  QuestionGroupType,
  QuestionType
} from '../../../../generated/base-types';
import { TaskUserFragment } from './load-task-options.generated';

@Component({
  selector: 'co-confirm-create-task-modal',
  templateUrl: './confirm-create-task-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmCreateTaskModalComponent {
  @Input() public modalInstance: NgbModalRef;
  @Input() public users: TaskUserFragment[];
  @Input() public subject: string;
  @Input() public body: string;
  @Input() public questionTypes: QuestionType[];
  @Input() public questionGroupTypes: QuestionGroupType[];

  public onDismiss(): void {
    this.modalInstance.dismiss();
  }

  public onConfirm(): void {
    this.modalInstance.close();
  }
}
